export default __webpack_public_path__ + "static/media/biker_in_route.5af33e60.svg";